import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonService } from './common.service';

@Injectable()
export class SubscriptionService implements Resolve<any>{
    subscription_details: any = {};
    onSubscritionDetailsChanged: BehaviorSubject<any>;

    payment_details: any = {};
    onPaymentDetailsChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private _commonService: CommonService
    ) {
        this.onSubscritionDetailsChanged = new BehaviorSubject([]);
        this.onPaymentDetailsChanged = new BehaviorSubject([]);

    }


    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

      return new Promise <void> ((resolve, reject) => {

            Promise.all([

            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }



    getSubscriptionDetails(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.post<any>('api/subscription/getsubscriptiondetails?admin_id=' + this._commonService.admin_id, {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            }).subscribe((response: any) => {
                this.subscription_details = response;
                this.onSubscritionDetailsChanged.next(this.subscription_details);
                resolve(this.subscription_details);
            }, reject);
        });
    }

    getModuleDetails<T>(): Observable<T> {
     
        return this._httpClient.post<T>('api/subscription/getmoduledetails?admin_id=' + this._commonService.admin_id, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }



    getPaymentDetails(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.post<any>('api/subscription/getpaymentdetails?admin_id=' + this._commonService.admin_id, {
                headers: new HttpHeaders({
                    "Content-Type": "application/json"
                })
            }).subscribe((response: any) => {
                this.payment_details = response;
                this.onPaymentDetailsChanged.next(this.payment_details);
                resolve(this.payment_details);
            }, reject);
        });
    }

    getInvoiceList<T>(): Observable<T> {

        return this._httpClient.post<T>('api/subscription/getinvoicelist?admin_id=' + this._commonService.admin_id, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }

    getInvoiceByID<T>(invoice_id): Observable<T> {

        return this._httpClient.post<T>('api/subscription/getinvoicebyid?invoice_id=' + invoice_id, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }


    EnableDisableModule<T>(data): Observable<T> {
    
        return this._httpClient.post<T>('api/subscription/updatesubscription', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }


    CancelSubscription<T>(data): Observable<T> {
      
        return this._httpClient.post<T>('api/subscription/cancelsubscription', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }

    ReactivateSubscription<T>(data): Observable<T> {
        return this._httpClient.post<T>('api/subscription/reactivatesubscription', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }


    AddCard<T>(data): Observable<T> {
  
        return this._httpClient.post<T>('api/subscription/addcard', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }

    UpdateCard<T>(data): Observable<T> {
   
        return this._httpClient.post<T>('api/subscription/updatecard', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }

    ResumeSubscription<T>(data): Observable<T> {
  
        return this._httpClient.post<T>('api/subscription/resumesubscription', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }

    PayLastUnpaidInvoice<T>(data): Observable<T> {

        return this._httpClient.post<T>('api/subscription/paylastunpaidinvoice', data, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        })
    }
}
